//
//
//
//
//
//
//
//
//

  export default {
    name: 'App',
    data(){
      return{
        isIE: '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
      }
    },
    mounted(){
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        window.addEventListener('hashchange', () => {
          let currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        }, false)
      }
    }
  }



// WEBPACK FOOTER //
// ./src/App.vue